<style lang="scss" scope>
.ivu-tabs .ivu-tabs-tabpane {
  flex-shrink: 0;
  width: 100%;
  transition: opacity 0.3s;
  opacity: 1;
  outline: none;
}
.ivu-modal-wrap * {
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.ivu-pb,
.ivu-pb-16 {
  padding-bottom: 16px !important;
}
.row[data-v-75eea3a4] {
  display: flex;
  border-bottom: 1px dashed #dee5e7;
  padding: 10px;
}
.row .col[data-v-75eea3a4] {
  width: 0;
  flex: 1;
  display: flex;
  padding: 0 15px;
}
.row .col .label[data-v-75eea3a4] {
  padding: 0 15px;
  flex-shrink: 0;
  width: 100px;
}
.row .col > div[data-v-75eea3a4] {
  padding: 14px 15px;
  font-weight: 700;

  .cell {
    text-align: center;
  }
}
.step_p{
    color:#000;
    p{
    line-height: 8px;}
}
.flex_start{
    display: flex;
    align-items: flex-start;
}
.el-step__icon.is-text{
    font-size:0;
    margin-left: 5px;
    top: -7px;
    width:15px;
    height: 15px;
}
.el-step__description.is-finish{
color:#000;
}
.el-step__main{
    margin-top: -12px;
}


</style>
<template>
  <div class="l-edit-dialog-box" style="padding-top:15px">
    <p>时间：{{info_data.created_at}}</p>
    
    <el-card class="box-card">
  <div slot="header" class="clearfix">
    <span>卡片名称</span>
    <!-- <span style="float: right; padding: 3px 0">新增隐患</span> -->
  </div>
  <div class="text item">
    <div>
    <p class="xf_title">隐患图片：</p>
    <img class="xf_img" v-for="(item, index) in info_data.photo" :key="index" :src="item"  alt="">
    <p v-if="info_data.photo.length == 0">暂无隐患图片</p>
    </div>
    <div>
    <p class="xf_title">整改图片：</p>
    <img class="xf_img" v-for="(item, index) in info_data.rectification_photo" :key="index" :src="item"  alt="">
    <p  v-if="info_data.rectification_photo.length == 0">暂无整改图片</p>
    </div>
    <el-divider></el-divider>
    <div class="xf_title_box">
        <p class="xf_title">检查规则：</p>
        <p>{{info_data.danger}}</p>
    </div>
    <div class="xf_title_box">
        <p class="xf_title">详细描述：</p>
        <p>1</p>
    </div>
    <div class="xf_title_box text_success">
        <p class="xf_title">整改建议：</p>
        <p>{{info_data.rectification}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;【描述详情：{{info_data.description_details}}】</p>
    </div>
  </div>
</el-card>
<p class="xf_title">隐患排查动态</p>
<div style="height:10px;"></div>
<el-steps direction="vertical" :active="99" class="step_p"  v-for="item in hidden_log" :key="item.id"> 
    <el-step title="" status="">
        <template slot="description">
            <p>操作人员：{{item.operator}} ---【{{item.type_name}}】</p>
            <p>操作时间：{{item.created_at}}</p>
            <p v-if="item.remark == ''" >备注信息：{{item.remark}}</p>
            <p v-if="item.photo.length == 0" class="flex_start" >图片信息：
                <img class="xf_img" v-for="(item, index) in item.photo" :key="index" :src="item"  alt="">
            </p>
        </template>
    </el-step>
    <!-- <el-step title=""></el-step> -->
  </el-steps>
   
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>

</template>

<script>

export default {
  name: 'l-hidden-info',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
  },

  components: {
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
          setTimeout(()=>{
            this.percentage=100
          },100)
        }
      }
    }
  },
  data() {
    return {
      loading: false,//页面是否加载中
      //表单数据
      form_data: {
      },
      facade_photo: "",
      danger_notification_photo: "",
      signature_photo: "",
      sign_for_photo: "",
      work_photo: "",
      activeName: 'first',
      info_data: {
        rectification_photo:[],
        photo:[]
      },
      percentage:0,
      hidden_log:[],
    }
  },
  methods: {
    getData(){
        if (this.hasId) {
        // console.log(this.$props.id)
        this.loading = true;
        this.$_invoke(`hiddenDanger_details`, { hidden_id: this.$props.id
        }).then((ret) => {
          // console.log(ret)
          this.info_data = ret.data ;
             this.hidden_log = ret.log;
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
  },
}
</script>